<template>
  <div class="text-right">
    <breeze-secondary-button class="my-2">
        <inertia-link  :href="route('staff.vendors.create')" class="underline text-sm text-gray-600 hover:text-gray-900">
                    + New Reseller
                </inertia-link>
    </breeze-secondary-button>
  </div>
  <div>
    <table key="vendors" id="vendor-datatable" class="stripe hover">
      <thead>
        <tr>
          <th>id</th>
          <th>ชื่อ</th>
          <th>status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody></tbody>
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <breeze-dialog-modal
      :show="tokenModal"
      @close="closeComfirmSalePageModal"
    >
      <template #title> token ของ reseller</template>

      <template #content>
        <p>
          ระบบได้ทำการยกเลิก token เดิม และสร้าง token ใหม่แล้ว กรุณาจดไว้ก่อนที่จะปิดหน้านี้
          <br>
          token ใหม่คือ 
        </p>
        
      </template>

      <template #footer>
        <breeze-input
            v-on:focus="$event.target.select()" 
            ref="clone" 
            readonly 
            :value="newToken"
            class="w-9/12 mr-2 px-2"
            /> 
        <breeze-secondary-button @click="copyToClipboard">copy</breeze-secondary-button>

        <breeze-secondary-button class="mt-2" @click="closeComfirmSalePageModal">
          ปิดหน้าต่าง
        </breeze-secondary-button>
      </template>
    </breeze-dialog-modal>
</template>

<script>
import BreezeSecondaryButton from "@/Components/SecondaryButton";
import BreezeDialogModal from "@/Components/DialogModal";
import BreezeInput from "@/Components/Input";

export default {
  props: [],
  components: {
    BreezeSecondaryButton,
    BreezeDialogModal,
    BreezeInput,
  },
  data() {
    return {
        tokenModal: false,
        newToken: "",
        isChecking: false,
    };
  },
  mounted() {
    let parent = this;
    $("#vendor-datatable").DataTable({
      dom: "tpr",
      pageLength: 50,
      processing: true,
      serverSide: true,
      order: [[0, "asc"]],
      ajax: "/staff/vendors/datatable",
      columns: [
        { data: "id", name: "id", 
          orderable: false,
          searchable: false,},
        { data: "name", name: "name" },
        { data: "status", name: "status",
          orderable: false,
          searchable: false,},
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            let btn = `
                <button type="button" class="bg-blue-500 mr-2 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded documentBtn" data-id="${data}"><i class="fa fa-edit"></i> แสดง</button>
                <button type="button" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded tokenBtn" data-id="${data}"><i class="fa fa-cogs"></i> +token</button>
                <button type="button" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 rounded activeBtn" data-id="${data}"><i class="fa fa-cross"></i> active/inactive</button>`;
            return btn;
          },
        },
      ],
      initComplete: function () {
        //setup datatable when all data ready
        this.api()
          .columns([1,2])
          .every(function (i) {
            let column = this;
            let input = null;

            input = $(document.createElement("input"));

            input
              .addClass(
                "border border-gray-300 p-2 my-2 rounded-md focus:outline-none focus:ring-2 ring-blue-200 w-full"
              )
              .appendTo($(column.footer()).empty())
              .on("change", function () {
                column.search($(this).val(), false, false, true).draw();
              });
          });
        this.find("tfoot tr").appendTo(this.find("thead"));
      },
      drawCallback: function (settings) {
        $(".documentBtn").click(function () {
          let editRoute = route("staff.vendors.edit", {
            vendor: $(this).data("id"),
          });
          parent.$inertia.get(editRoute);
        });
        
        $(".tokenBtn").click(function () {          
            parent.getToken($(this).data("id"));
        });
        $(".activeBtn").click(function () {
          let deleteRoute = route("staff.vendors.inactive", {
            vendor: $(this).data("id"),
          });
          parent.$inertia.put(deleteRoute);
        });
      },
    });
  },
  methods: {
    closeComfirmSalePageModal() {
        this.tokenModal = false;
        this.newToken = "";
    },
    copyToClipboard() {
        const type = "text/plain";
        const blob = new Blob([this.newToken], { type });
        const data = [new ClipboardItem({ [type]: blob })];
        navigator.clipboard.write(data).then(
        () => {
            //onDone();
        },
        (err) => {
            //onError(err);
        },);
    },
    getToken(vendorId) {
        if (this.isChecking == false) {
            this.isChecking = true;
            this.isOpenNextSteps = false;

            axios
                .get(
                route("staff.vendors.token", {
                    vendor: vendorId
                })
                )
                .then((response) => {
                if (response.data.result == 'success') {
                    
                    this.newToken = response.data.token;
                    this.tokenModal = true;
                }

                this.isChecking = false;
                });
        }
    }
  }
};
</script>
